import { render, staticRenderFns } from "./ListWatches.vue?vue&type=template&id=536e685b&scoped=true"
import script from "./ListWatches.vue?vue&type=script&lang=js"
export * from "./ListWatches.vue?vue&type=script&lang=js"
import style0 from "./ListWatches.vue?vue&type=style&index=0&id=536e685b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e685b",
  null
  
)

export default component.exports